var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_camera") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 24 0 24 15.5619252 0 15.5619252"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-Video-Visit-5",
    transform: "translate(-595.000000, -271.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_camera",
    transform: "translate(595.000000, 271.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1412567,11.9906598 C22.1412567,12.0907222 22.0839455,12.1440061 22.035928,12.1712677 C21.9876006,12.1982195 21.9126313,12.219595 21.8265096,12.1684796 L18.2320099,10.3342098 L18.2320099,5.22762247 L21.7691983,3.4252611 L21.8265096,3.39366246 C21.9123215,3.34223723 21.9876006,3.36361278 22.035928,3.39056455 C22.0839455,3.41782612 22.1412567,3.47141989 22.1412567,3.57148223 L22.1412567,11.9906598 Z M16.3732666,12.9160042 C16.3732666,13.3503305 16.0201054,13.7031819 15.5860889,13.7031819 L2.64582809,13.7031819 C2.21181154,13.7031819 1.85865032,13.3503305 1.85865032,12.9160042 L1.85865032,2.64582809 C1.85865032,2.21181154 2.21181154,1.85865032 2.64582809,1.85865032 L15.5860889,1.85865032 C16.0201054,1.85865032 16.3732666,2.21181154 16.3732666,2.64582809 L16.3732666,4.08883244 L16.3732666,11.4729998 L16.3732666,12.9160042 Z M22.9504296,1.77252855 C22.3045164,1.40759529 21.5408827,1.41131278 20.9002358,1.78213206 L18.2320099,3.14180275 L18.2320099,2.64582809 C18.2320099,1.18671463 17.0452023,-9.29371629e-05 15.5860889,-9.29371629e-05 L2.64582809,-9.29371629e-05 C1.18702442,-9.29371629e-05 -9.29371627e-05,1.18671463 -9.29371627e-05,2.64582809 L-9.29371627e-05,12.9160042 C-9.29371627e-05,14.3751176 1.18702442,15.5619252 2.64582809,15.5619252 L15.5860889,15.5619252 C17.0452023,15.5619252 18.2320099,14.3751176 18.2320099,12.9160042 L18.2320099,12.4203393 L20.9005456,13.78001 C21.2236572,13.9671235 21.5780575,14.0606802 21.9330775,14.0606802 C22.2815919,14.0606802 22.630416,13.9705312 22.9507394,13.7893037 C23.6078052,13.4175551 24,12.7456194 24,11.9906598 L24,3.57148223 C24,2.81652268 23.6074954,2.14396741 22.9504296,1.77252855 L22.9504296,1.77252855 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon_camera.b2ce84b2a808b5abc4117d18c88b4a05.svg";
export { ForwardRef as ReactComponent };